import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { CompanyApiEffects } from './company-api.effects';
import { CompanyEffects } from './company.effects';
import { CompanyNotificationEffects } from './company-notification.effects';
import { CompanyProfileEffects } from './company-profile.effects';
import { reducer, featureKey } from './reducers';

@NgModule({
  imports: [
    StoreModule.forFeature(featureKey, reducer),
    EffectsModule.forFeature([
      CompanyApiEffects,
      CompanyEffects,
      CompanyNotificationEffects,
      CompanyProfileEffects,
    ]),
  ],
})
export class CompanyStateModule {}
